import { PERMISSIONS } from '@/generated/permissions'

export const cleaningRoutes = [
  {
    component: () => import('@/domains/cleaning/pages/cleaners/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.CLEANER_READ,
        PERMISSIONS.CLEANER_CREATE,
        PERMISSIONS.CLEANER_UPDATE,
        PERMISSIONS.CLEANER_DEACTIVATE,
        PERMISSIONS.CLEANER_TOKEN_ROTATE,
      ],
      requiresAuth: true,
    },
    name: 'cleaning-cleaners-index',
    path: '/cleaning/cleaners',
  },
  {
    component: () => import('@/domains/cleaning/pages/catalog/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.CATALOG_READ,
        PERMISSIONS.CATALOG_CREATE,
        PERMISSIONS.CATALOG_UPDATE,
        PERMISSIONS.CATALOG_DEACTIVATE,
        PERMISSIONS.CATALOG_REFRESH,
      ],
      requiresAuth: true,
    },
    name: 'cleaning-catalog-index',
    path: '/cleaning/catalog',
  },
  {
    component: () => import('@/domains/cleaning/pages/requests/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.REQUEST_READ,
        PERMISSIONS.REQUEST_APPROVE,
        PERMISSIONS.REQUEST_REJECT,
        PERMISSIONS.REQUEST_DELETE,
      ],
      requiresAuth: true,
    },
    name: 'cleaning-requests-index',
    path: '/cleaning/requests',
  },
  {
    component: () => import('@/domains/cleaning/pages/public/RequestPage.vue'),
    meta: {
      layout: false,
      requiresAuth: false,
    },
    name: 'cleaning-public-request',
    path: '/cleaning/request',
  },
]
